/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Guidevideo_Play_Aria1Inputs */

const vi_guidevideo_play_aria1 = /** @type {(inputs: Guidevideo_Play_Aria1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Xem video ${i?.title}`)
};

/**

* @param {Guidevideo_Play_Aria1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_play_aria1 = /** @type {((inputs: Guidevideo_Play_Aria1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Play_Aria1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_play_aria1(inputs)
});
export { guidevideo_play_aria1 as "guideVideo_play_aria" }